<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Sample" :label-cols="3">
          <b-form-input
            type="text"
            v-model="identifier"
            placeholder="Enter Project Name"
            :state="!$v.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Animal Fed"
          :label-cols="3"
          :state="!$v.sample_form.sample_feeds.animal_fed.$invalid"
          invalid-feedback="Required"
        >
          <form-selector
            :selectedItem="sample_form.sample_feeds.animal_fed"
            :customPlaceholder="'Select Sample Animal Fed'"
            :options="animalFedOptions"
            @change="handleSelect"
          ></form-selector>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Feed Type"
          :label-cols="3"
          :state="!$v.sample_form.sample_feeds.type.$invalid"
          invalid-feedback="Required"
        >
          <form-selector
            :selectedItem="sample_form.sample_feeds.type"
            :customPlaceholder="'Select Sample Type'"
            :options="feedTypeOptions"
            :loading="attributeList.loading"
            @change="handleSelect"
          ></form-selector>
        </b-form-group>
      </b-col>
    </b-row>
    <add-on-select
      :selectedAddOns="sample_form.add_ons"
      :addOns="addOns"
      @onAddOnSelect="onAddOnSelect"
    ></add-on-select>
  </div>
</template>

<script>
import AddOnSelect from "../../AddOnSelect";
import FormSelector from "../../FormSelector";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import AttributeListCollection from '../../../../collections/lab/AttributeListCollection'

export default {
  name: "FeedsSampleFormGroup",
  components: {
    AddOnSelect,
    FormSelector
  },
  mixins: [validationMixin, ToastNotifications],
  props: ["sample", "addOns", "index", "typeOptions", "animalFedOptions", "managedListId"],
  computed: {
    identifier: {
      get() {
        return this.sample_form.identifier;
      },
      set(value) {
        this.sample_form.identifier = value;
        this.handleSampleChange();
      }
    },
    feedTypeOptions () {
      return {
        field: 'type',
        options: this.attributeList.models.map((item) => {
          return { id: item.id, name: item.value, parent_id: item.parent_id, managed_list_id: item.managed_list_id }
        })
      }
    }
  },
  data() {
    return {
      sample_form: {
        test_package_sample_id: null,
        identifier: null,
        add_ons: [],
        sample_feeds: {
          type: null,
          animal_fed: null
        }
      },

      attributeList: new AttributeListCollection()
    };
  },
  validations: {
    identifier: { required },
    sample_form: {
      sample_feeds: {
        type: { required },
        animal_fed: { required }
      }
    }
  },
  watch: {
    'sample_form.sample_feeds.animal_fed' () {
      this.fetchFeedTypeOptions()
    }
  },
  methods: {
    handleSampleChange() {
      const params = { ...this.sample_form };
      this.$emit("onSampleChange", {
        sample: params,
        index: this.index
      });
    },
    onAddOnSelect(addOns) {
      this.sample_form.add_ons = [...addOns];
      this.handleSampleChange();
    },
    handleSelect({ selected, field }) {
      this.sample_form.sample_feeds[field] = selected;
      this.handleSampleChange();
    },
    async fetchFeedTypeOptions () {
      let filter = this.attributeList.getFilter()
      filter.resetFilters()
      filter.resetSort()
      
      filter.filterEquals('managed_list_id', this.managedListId)
      filter.filterEquals('parent.parent_id', this.sample_form.sample_feeds.animal_fed)

      filter.sortAddAsc('value')

      await this.attributeList.fetch({ params: { limit: 'all' } })
    }
  },
  beforeMount() {
    const form_data = JSON.parse(JSON.stringify(this.sample));
    if (form_data && form_data.test_package_sample_id) {
      const {
        test_package_sample_id,
        identifier,
        add_ons,
        sample_feeds
      } = form_data;
      this.sample_form = {
        test_package_sample_id,
        identifier,
        add_ons: (add_ons && [...add_ons]) || [],
        sample_feeds: { ...sample_feeds }
      };
    }
  }
};
</script>
